import React from 'react';
import AsyncSelect from "react-select/async";
import { useAppDispatch } from "../../../app/store";
import { ADMIN_LANG } from "../../../settings";
import { PlainDetails } from "../../../types/admin";
import { getPlainCollections } from "../../../app/slices/admin";

interface AsyncCollectionsSelectProps {
    onChange: (value: PlainDetails[]) => void;
    initialValues: PlainDetails[];
    selectedCollections: PlainDetails[];
}

const AsyncCollectionsSelect = ({ onChange, initialValues, selectedCollections }: AsyncCollectionsSelectProps) => {
    const dispatch = useAppDispatch();

    const loadOptions = (input: string) => {
        return new Promise<PlainDetails[]>((resolve) => {
            if (input.length < 2) {
                return resolve([]);
            }

            dispatch(getPlainCollections(input))
                .then((fulfilledAction) => {
                    const data: PlainDetails[] = fulfilledAction.payload.collections;
                    resolve(data);
                })
                .catch(() => resolve([]));
        });
    };

    return (
        <AsyncSelect
            value={selectedCollections}
            cacheOptions
            defaultOptions={initialValues.length > 0 ? initialValues : undefined}
            isMulti
            loadOptions={loadOptions}
            noOptionsMessage={() => ADMIN_LANG.search}
            onChange={(selectedValues) => onChange(selectedValues as PlainDetails[])}
            placeholder={ADMIN_LANG.select_collections}
            classNamePrefix="react-select"
            className="custom-react-select"
        />
    );
};

export default AsyncCollectionsSelect;
